(function() {
    class CollectionSliderAdev extends HTMLElement {
        constructor() {
            super();
            this.currentIndex = 0;
            this.isMobile = window.innerWidth <= 749;
            this.itemsPerView = this.isMobile ? 1 : 3;
            this.isDragging = false;
            this.startPos = 0;
            this.currentTranslate = 0;
            this.prevTranslate = 0;
            this.animationID = 0;
        }

        connectedCallback() {
            this.track = this.querySelector('.ai-collection-slider-track-adev');
            this.cards = this.querySelectorAll('.ai-collection-card-adev');
            this.dotsContainer = this.querySelector('.ai-slider-dots-adev');

            if (this.cards.length === 0) return;

            this.totalItems = this.cards.length;
            this.maxIndex = Math.max(0, this.totalItems - this.itemsPerView);

            this.setupEventListeners();
            this.createDots();
            this.updateDots();

            window.addEventListener('resize', () => {
                const wasMobile = this.isMobile;
                this.isMobile = window.innerWidth <= 749;
                if (wasMobile !== this.isMobile) {
                    this.itemsPerView = this.isMobile ? 1 : 3;
                    this.maxIndex = Math.max(0, this.totalItems - this.itemsPerView);
                    this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
                    this.createDots();
                    this.updateSlider();
                }
            });
        }

        setupEventListeners() {
            this.track.addEventListener('mousedown', this.touchStart.bind(this));
            this.track.addEventListener('touchstart', this.touchStart.bind(this));
            this.track.addEventListener('mouseup', this.touchEnd.bind(this));
            this.track.addEventListener('touchend', this.touchEnd.bind(this));
            this.track.addEventListener('mouseleave', this.touchEnd.bind(this));
            this.track.addEventListener('mousemove', this.touchMove.bind(this));
            this.track.addEventListener('touchmove', this.touchMove.bind(this));

            this.cards.forEach(card => {
                card.addEventListener('dragstart', (e) => e.preventDefault());
            });
        }

        createDots() {
            if (this.isMobile) return;

            this.dotsContainer.innerHTML = '';
            const numDots = this.maxIndex + 1;

            for (let i = 0; i < numDots; i++) {
                const dot = document.createElement('button');
                dot.classList.add('ai-slider-dot-' + this.dataset.id);
                dot.classList.add('ai-slider-dot-adev');
                dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
                dot.addEventListener('click', () => {
                    this.currentIndex = i;
                    this.updateSlider();
                });
                this.dotsContainer.appendChild(dot);
            }
        }

        updateDots() {
            if (this.isMobile) return;

            const dots = this.dotsContainer.querySelectorAll('.ai-slider-dot-adev');
            dots.forEach((dot, index) => {
                if (index === this.currentIndex) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }
            });
        }

        getPositionX(event) {
            return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
        }

        touchStart(event) {
            this.isDragging = true;
            this.startPos = this.getPositionX(event);
            this.track.classList.add('dragging');
            this.animationID = requestAnimationFrame(this.animation.bind(this));
        }

        touchMove(event) {
            if (this.isDragging) {
                const currentPosition = this.getPositionX(event);
                this.currentTranslate = this.prevTranslate + currentPosition - this.startPos;
            }
        }

        touchEnd() {
            if (!this.isDragging) return;

            this.isDragging = false;
            cancelAnimationFrame(this.animationID);
            this.track.classList.remove('dragging');

            const movedBy = this.currentTranslate - this.prevTranslate;
            const cardWidth = this.cards[0].offsetWidth;
            const gap = this.dataset.cardGap ? parseInt(this.dataset.cardGap) : 0;

            if (movedBy < -(cardWidth / 4) && this.currentIndex < this.maxIndex) {
                this.currentIndex++;
            }

            if (movedBy > cardWidth / 4 && this.currentIndex > 0) {
                this.currentIndex--;
            }

            this.updateSlider();
        }

        animation() {
            this.track.style.transform = `translateX(${this.currentTranslate}px)`;
            if (this.isDragging) {
                requestAnimationFrame(this.animation.bind(this));
            }
        }

        updateSlider() {
            const cardWidth = this.cards[0].offsetWidth;
            const gap = this.dataset.cardGap ? parseInt(this.dataset.cardGap) : 0;
            const offset = this.currentIndex * (cardWidth + gap);

            this.prevTranslate = -offset;
            this.currentTranslate = -offset;
            this.track.style.transform = `translateX(-${offset}px)`;
            this.track.style.transition = 'transform 0.4s ease';

            setTimeout(() => {
                this.track.style.transition = '';
            }, 400);

            this.updateDots();
        }
    }

    customElements.define('collection-slider-adev', CollectionSliderAdev);
})();